import { render, staticRenderFns } from "./Servidores.vue?vue&type=template&id=c420ea98"
import script from "./Servidores.vue?vue&type=script&lang=js"
export * from "./Servidores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports